import { render } from "./CustomerDetails.vue?vue&type=template&id=011f10bc&scoped=true&ts=true"
import script from "./CustomerDetails.vue?vue&type=script&lang=ts"
export * from "./CustomerDetails.vue?vue&type=script&lang=ts"

import "./CustomerDetails.vue?vue&type=style&index=0&id=011f10bc&scoped=true&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011f10bc"]])

export default __exports__